import React from 'react';
import {
  Image,
  ProductTileImage,
  ProductTileImageProps,
} from '../ProductTileImage/ProductTileImage';

interface ProductTileSelectorProps extends ProductTileImageProps {
  productTileGalleryMode?: 'hover' | 'always';
  imageGallery: Image[];
  trackGallerySwipe?: VoidFunction;
  className?: string;
  enableImageGalleryAnimation?: boolean;
  preferModelImage?: boolean;
  openInNewTab?: boolean;
  onClick?: React.MouseEventHandler<Element>;
}

export const ProductTileSelector = ({
  productTileGalleryMode,
  primaryImage,
  secondaryImage,
  imageGallery,
  trackGallerySwipe,
  children,
  ref,
  ...rest
}: React.PropsWithChildren<ProductTileSelectorProps> & {
  ref?: React.Ref<HTMLAnchorElement>;
}) => {
  return (
    <ProductTileImage
      ref={ref}
      primaryImage={primaryImage}
      secondaryImage={secondaryImage}
      imageGallery={imageGallery}
      productTileGalleryMode={productTileGalleryMode}
      trackGallerySwipe={trackGallerySwipe}
      {...rest}
    >
      {children}
    </ProductTileImage>
  );
};
